import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class TextBlockAnimation {
	constructor() {
		this.container = document.querySelector('[data-text-block]')
		if (!this.container) return

		this.overlays = this.container.querySelectorAll('[data-grid-overlays]')

		if (!this.overlays.length) return

		this.#init()
	}

	#init() {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.container,
				start: 'bottom bottom',
				scrub: true,
			},
		})

		tl.to(this.overlays, {
			height: '100%',
			stagger: {
				each: 0.125,
				ease: 'power1.inOut',
			},
			ease: 'none',
		})
	}
}
